exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width:768px){.action-wrapper[data-v-3640738d]{display:flex;justify-content:flex-end;align-items:center}.action-wrapper>[data-v-3640738d]{margin:10px;margin-left:5px}.background-white[data-v-3640738d]{background-color:#fff}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3640738d","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/layouts/MobileActionTop.vue
// module id = 528
// module chunks = 187